import React, { createRef, useMemo, useState } from "react";
import Headerback from "../../../component/headerback";
import Question from "../../pretest/question";

// 新的填空题数据
let gapPro = [
    {
        idPro: 1,
        upper: '天生我材必有用，',
        next: '千金散尽还复来。',
        title: '（《将进酒》李白）',
        show: 1,   // 填空位置在上句
    },
    {
        idPro: 2,
        upper: '万里悲秋常作客，',
        next: '百年多病独登台。',
        title: '（《登高》杜甫）',
        show: -1,  // 填空位置在下句
    },
    {
        idPro: 3,
        upper: '浊酒一杯家万里，',
        next: '燕然未勒归无计。',
        title: '（《渔家傲·秋思》范仲淹）',
        show: -1,  // 填空位置在下句
    },
];

// 新的选择题数据
const defalutschema = {
    id: 1,
    desc: '检测一',
    totalScore: 0,
    question: [
        {
            id: 2,
            desc: '阅读杜甫《登高》尾联：“艰难苦恨繁霜鬓，潦倒新停浊酒杯”。下列对句中“浊酒”意象的理解，最恰当的一项是（ ）',
            the_score: 0,
            options: [
                {
                    label: '“浊酒”与李白“金樽清酒”形成对比，意在批评李白过于追求物质享受，而杜甫更注重精神追求。',
                    value: '“浊酒”与李白“金樽清酒”形成对比，意在批评李白过于追求物质享受，而杜甫更注重精神追求。',
                    score: 0,
                    selected: false,
                },
                {
                    label: '“浊酒”象征着诗人晚年生活的困顿，但“新停”二字暗示诗人因身体原因无法饮酒，反而让愁绪失去排解的途径，酒未入口而愁已满杯。',
                    value: '“浊酒”象征着诗人晚年生活的困顿，但“新停”二字暗示诗人因身体原因无法饮酒，反而让愁绪失去排解的途径，酒未入口而愁已满杯。',
                    score: 1,
                    selected: false,
                },
                {
                    label: '“浊酒”说明诗人经济拮据，喝不起好酒，表达了对社会不公的强烈控诉。',
                    value: '“浊酒”说明诗人经济拮据，喝不起好酒，表达了对社会不公的强烈控诉。',
                    score: 0,
                    selected: false,
                },
                {
                    label: '“新停浊酒杯”是因为诗人戒酒养生，体现了杜甫在困境中依然保持理性克制的精神品质。',
                    value: '“新停浊酒杯”是因为诗人戒酒养生，体现了杜甫在困境中依然保持理性克制的精神品质。',
                    score: 0,
                    selected: false,
                },
            ],
            selected: [],
        },
    ],
};

window.localStorage.schema = JSON.stringify(defalutschema);

let a_schema;
try {
    a_schema = JSON.parse(window.localStorage.schema);
} catch { }

export default function Classone() {
    const filteredPool = [0, 1, 2];   // 固定题目索引

    const [schema] = useState(a_schema);
    let { question, desc } = schema;
    const [finish, setFinish] = useState(false);
    const [finishScore, setFinishScore] = useState(0);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [show, setShow] = useState([-1, -1, -1]);
    const [inputValue1, setInputValue1] = useState('');
    const [inputValue2, setInputValue2] = useState('');
    const [inputValue3, setInputValue3] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    let totalScore;
    let newSchema = { id: 1, totalScore: 0, question: [] };

    const refs = useMemo(() => question.map(() => createRef()), [question]);

    const handleSave = () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        setBtnDisabled(true);

        setFinish(true);
        totalScore = 0;
        schema.question.forEach((item, index) => {
            const { getSchema } = refs[index].current;
            newSchema.question.push(getSchema());
            if (getSchema().the_score) {
                totalScore += getSchema().the_score;
            }
        });

        let trueAnswer = [];
        filteredPool.forEach((item, index) => {
            if (index === 0) {
                if (gapPro[item].show === -1) {
                    trueAnswer.push(gapPro[item].next.replace(/。/g, ""));
                    if (inputValue1 === gapPro[item].next.replace(/。/g, "")) {
                        totalScore += 1;
                        const newShow = [...show];
                        newShow[index] = 1;
                        setShow(newShow);
                    } else {
                        const newShow = [...show];
                        newShow[index] = 0;
                        setShow(newShow);
                    }
                } else if (gapPro[item].show === 1) {
                    trueAnswer.push(gapPro[item].upper.replace(/，/g, ""));
                    if (inputValue1 === gapPro[item].upper.replace(/，/g, "")) {
                        totalScore += 1;
                        const newShow = [...show];
                        newShow[index] = 1;
                        setShow(newShow);
                    } else {
                        const newShow = [...show];
                        newShow[index] = 0;
                        setShow(newShow);
                    }
                }
            } else if (index === 1) {
                if (gapPro[item].show === -1) {
                    trueAnswer.push(gapPro[item].next.replace(/。/g, ""));
                    if (inputValue2 === gapPro[item].next.replace(/。/g, "")) {
                        totalScore += 1;
                        const newShow = [...show];
                        newShow[index] = 1;
                        setShow(newShow);
                    } else {
                        const newShow = [...show];
                        newShow[index] = 0;
                        setShow(newShow);
                    }
                } else if (gapPro[item].show === 1) {
                    trueAnswer.push(gapPro[item].upper.replace(/，/g, ""));
                    if (inputValue2 === gapPro[item].upper.replace(/，/g, "")) {
                        totalScore += 1;
                        const newShow = [...show];
                        newShow[index] = 1;
                        setShow(newShow);
                    } else {
                        const newShow = [...show];
                        newShow[index] = 0;
                        setShow(newShow);
                    }
                }
            } else if (index === 2) {
                if (gapPro[item].show === -1) {
                    trueAnswer.push(gapPro[item].next.replace(/。/g, ""));
                    if (inputValue3 === gapPro[item].next.replace(/。/g, "")) {
                        totalScore += 1;
                        const newShow = [...show];
                        newShow[index] = 1;
                        setShow(newShow);
                    } else {
                        const newShow = [...show];
                        newShow[index] = 0;
                        setShow(newShow);
                    }
                } else if (gapPro[item].show === 1) {
                    trueAnswer.push(gapPro[item].upper.replace(/，/g, ""));
                    if (inputValue3 === gapPro[item].upper.replace(/，/g, "")) {
                        totalScore += 1;
                        const newShow = [...show];
                        newShow[index] = 1;
                        setShow(newShow);
                    } else {
                        const newShow = [...show];
                        newShow[index] = 0;
                        setShow(newShow);
                    }
                }
            }
        });

        newSchema.totalScore = totalScore;
        window.localStorage.schema = JSON.stringify(newSchema);
        setFinishScore(newSchema.totalScore);
        alert(`你本次答对${newSchema.totalScore}道题!\n1、答案：\n（1）天生我材必有用，千金散尽还复来。\n（2）万里悲秋常作客，百年多病独登台。\n（3）浊酒一杯家万里，燕然未勒归无计。\n\n2、解析：A项（错误）：将李杜简单对比并赋予价值判断，是对诗歌意象的机械解读。B项（正确）：准确抓住了“浊酒”的核心意蕴——它既是杜甫潦倒生活的真实写照，也是其悲苦情感的载体。对“新停”二字的理解最为深刻——诗人并非不想借酒消愁，而是因重病不得不戒酒。“想喝不能喝”的无奈，比“借酒消愁愁更愁”更令人心酸。C项（错误）：将诗歌意象窄化为对社会现实的直接控诉，忽略了诗歌情感的多重性与复杂性。D项（错误）：对“新停”的理解流于表面。“停杯”不是主动的“戒酒养生”，而是被迫的“不能饮酒”。故选B。`);
    };

    let flag = 0;
    const getPro = (item) => {
        flag++;
        if (item.show === -1) {
            if (flag === 1) {
                return (
                    <div className="wrapper">
                        ({flag})&nbsp;&nbsp;{item.upper}
                        <input type="text" className="question-input" onChange={changeInput1} />。
                        {getTag(flag - 1, show)}
                        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——{item.title}
                    </div>
                );
            } else if (flag === 2) {
                return (
                    <div className="wrapper">
                        ({flag})&nbsp;&nbsp;{item.upper}
                        <input type="text" className="question-input" onChange={changeInput2} />。
                        {getTag(flag - 1, show)}
                        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——{item.title}
                    </div>
                );
            } else if (flag === 3) {
                return (
                    <div className="wrapper">
                        ({flag})&nbsp;&nbsp;{item.upper}
                        <input type="text" className="question-input" onChange={changeInput3} />。
                        {getTag(flag - 1, show)}
                        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——{item.title}
                    </div>
                );
            }
        } else if (item.show === 1) {
            if (flag === 1) {
                return (
                    <div className="wrapper">
                        ({flag})&nbsp;&nbsp;
                        <input type="text" className="question-input" onChange={changeInput1} />，{item.next}
                        {getTag(flag - 1, show)}
                        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——{item.title}
                    </div>
                );
            } else if (flag === 2) {
                return (
                    <div className="wrapper">
                        ({flag})&nbsp;&nbsp;
                        <input type="text" className="question-input" onChange={changeInput2} />，{item.next}
                        {getTag(flag - 1, show)}
                        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——{item.title}
                    </div>
                );
            } else if (flag === 3) {
                return (
                    <div className="wrapper">
                        ({flag})&nbsp;&nbsp;
                        <input type="text" className="question-input" onChange={changeInput3} />，{item.next}
                        {getTag(flag - 1, show)}
                        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——{item.title}
                    </div>
                );
            }
        }
        return null;
    };

    const changeInput1 = (e) => setInputValue1(e.target.value);
    const changeInput2 = (e) => setInputValue2(e.target.value);
    const changeInput3 = (e) => setInputValue3(e.target.value);

    const getTag = (index, show) => {
        if (show[index] === 0) {
            return <div className="cuoicon iconfont icon-cuo"></div>;
        } else if (show[index] === 1) {
            return <div className="duiicon iconfont icon-zhengque-correct"></div>;
        } else {
            return "";
        }
    };

    return (
        <div>
            <Headerback showPage={2} />
            <div className="page course-page">
                <div className="page-con">
                    <div className="problem">
                        <div className="problem-inner">
                            <p className="desc">{desc}</p>

                            <div className="question">
                                <p className="title1">1、理解性默写</p>
                                {filteredPool.map((item, index) => {
                                    return getPro(gapPro[item]);
                                })}
                            </div>

                            {schema.question.map((item, index) => (
                                <div key={item.id} className="question">
                                    <p className="title">{item.id}、{item.desc}</p>
                                    <Question finish={finish} item={item} ref={refs[index]} yanz={[1, 2, 1, 1]} />
                                </div>
                            ))}
                        </div>
                    </div>
                    <button
                        className="miaov-btn miaov-btn-md problem-btn"
                        type="submit"
                        onClick={handleSave}
                        disabled={btnDisabled}
                        style={{
                            backgroundColor: btnDisabled ? 'gray' : '',
                            cursor: btnDisabled ? 'default' : 'pointer',
                            display: btnDisabled ? 'none' : 'inline-block',
                        }}
                    >
                        提交
                    </button>
                </div>
            </div>
        </div>
    );
}